module.exports = __webpack_public_path__ + "static/media/monthlyCheckPhoneCall.e91279ab.png";